import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 text-center" data-testid="not-found-page">
      <div>
        <p className="text-xs tracking-[0.22em] uppercase text-[hsl(var(--lxra-gold))] mb-3">404</p>
        <h1 className="font-display text-5xl sm:text-6xl tracking-[0.03em] text-[hsl(var(--lxra-fg))]">PAGE NOT FOUND</h1>
        <p className="mt-4 text-sm text-[hsl(var(--lxra-muted))] max-w-md mx-auto">
          The page you&apos;re looking for doesn&apos;t exist or may have moved.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center h-11 px-6 rounded-xl bg-[hsl(var(--lxra-gold))] text-[#0A0A0A] hover:bg-[hsl(var(--lxra-gold-hover))] transition-colors duration-200 text-xs uppercase tracking-[0.1em] font-semibold"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Home
        </Link>
      </div>
    </div>
  );
}
